import { createObjectsCard } from "./render-function.js";
const objectsList = document.querySelector(".objects-list");
const loadMoreBtn = document.querySelector(".load-more");
const filterBtns = document.querySelectorAll(".filter-btn ");


let allData = [];
let currentFilter = "all";
let page = 1;
const limit = 3;

async function fetchData() {
  try {
    const response = await fetch(`https://test.smarto.agency/smarto_complexes_list.json`);
    //кладемо отримані дані в масив
    allData = await response.json();
    renderItems();
  } catch (error) {
    objectsList.innerHTML = `<li style="color:red;">Помилка: ${error.message}</li>`;
  }
}
function getFilteredData() {
  if (currentFilter === "all") return allData;
  return allData.filter(item => item.type === currentFilter);
}
function renderItems() {
  const filteredData = getFilteredData();
  const end = page * limit; //1*3=3
  //відображення 3 карток відразу.
  const visibleItems = filteredData.slice(0, end);
  //генеруємо розмітку через функцію createObjectsCard
  const cardsHTML = createObjectsCard(visibleItems);
  //Вставляємо у список
  objectsList.innerHTML = cardsHTML;

  //Якщо кількість карток буде перевищувати чи дорівнює загальної кількості карток на сервері то кнопку приховали
  if (visibleItems.length >= filteredData.length) {
    loadMoreBtn.style.display="none";
    iziToast.info({
      title: "Готово",
      message: "Усі об`єкти завантажені",
      position: "topRight",
    });
  } else {
    loadMoreBtn.style.display = "block";
}
}

//клік по фільтру
filterBtns.forEach(btn => {
  btn.addEventListener("click", () => {
    filterBtns.forEach(b => b.classList.remove("active"));
    btn.classList.add("active");
    currentFilter = btn.dataset.filter;
    page = 1;
    renderItems();
  });
});

loadMoreBtn.addEventListener("click", () => {
  page++;
  renderItems();
});
// старт
fetchData();